<template>
    <section>
        <v-layout row style="width: 88%;margin: auto;">
        <v-data-table :headers="headers" 
                      :items="JobListings" 
                      item-key="Job_Title" 
                      class="elevation-1"
                      style="width:100%;margin-top:10px;">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Job_Title }}</td>
                    <td class="text-xs-center">{{ props.item.Link }}</td>
                    <td class="text-xs-center">{{ new Date(props.item.Created_On).toDateString() }} , {{ new Date(props.item.Created_On).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}}</td>
                    <td class="text-xs-center">{{ props.item.Enable }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="OpenUpdateJobListingModal(props.item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn color="error" icon class="btnAction" @click="OpenDeleteJobListingModal(props.item)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        
        </v-layout>
        <app-add-job-listing ref="UpdateAddJobListing" :dialog="UpdateAddJobListing" @close='CloseDialog'></app-add-job-listing>
    </section>
</template>
<script>

import appAddJobListing from '../dialogs/AddJobsListing'

export default {
    components: {
        appAddJobListing
    },
    data(){

        return {

            headers              : [ { text: 'Job Title',value: 'Job_Title' },
                                    { text: 'Web URL',value: 'Link' },
                                    { text: 'Created On',value: 'Created_On' },
                                    { text: 'Active',value: 'Enable' },
                                    { text: 'Actions' } ],
            UpdateAddJobListing  : false
        }
    },
    computed:{
        JobListings(){

            return this.$store.getters.GetJobListings
        }
    },
    methods:{
      OpenUpdateJobListingModal(JobListing){

          this.UpdateAddJobListing  = true
          this.$refs.UpdateAddJobListing.GetDetailstoUpdate(JobListing)
      },
      OpenDeleteJobListingModal(JobListing){
        if (confirm("Do you really want to delete?")) {
            let data = { "Listing_Id" : JobListing['_id']}
            this.$http.post(`${this.$store.getters.GetProductionUrl}/joblisting/deletejob`,data)
                    .then(response =>{
                        
                        this.$store.commit('DeleteIndividualJobListing',response["data"]["response"])
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Deleting Data","Color":"red","Close": false });
                    })
        }
      },
      CloseDialog(){

          this.UpdateAddJobListing    = false
      }
    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/joblisting/getjoblistings`)
                    .then(response =>{
                        
                        this.$store.commit('SetJobListings',response["data"]["response"])
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    }
}
</script>
<style>
.btnAction {
  margin: 4px;
  border: 1px solid #d3d3d37a;
}
</style>


